/* istanbul ignore file */
import { Redirect, RedirectProps, useLocation } from 'react-router-dom';
import { error as logError } from 'src/services/log';

export function TrackedRedirect(props: RedirectProps) {
  const { to } = props;
  const { pathname } = useLocation();
  logError(new Error(`Attempted to access invalid URL: "${pathname}" \n\n Redirecting  to "${to}"`));
  return <Redirect {...props} />;
}
